import { Role } from "elephant-web/gql";

export const ROLE_IDS = {
  [Role.Admin]: "55c6d868-3cf2-4eb7-a699-0c1144481463",
  [Role.Elephant]: "65ffd295-b039-43a1-bb06-3fd6ef5f6817",
  [Role.Root]: "7e9f425e-3373-45d3-b4d1-d4e062143664",
  [Role.Technician]: "c39fafc9-a4e2-4204-b39c-a7be70101ce7",
  [Role.Nurse]: "f7ca5969-4d98-46d5-8e70-cc9f4fe8b91f",
  [Role.Clinic]: "f9b64975-b133-4d6b-9d16-c497c6eefa3a",
  [Role.Doctor]: "fe8c7bf1-20b4-4d6b-9214-cf6aa8bb56a3",
  [Role.Pharmacist]: "90bb621f-f35a-4c8f-a060-8226fc7e975c",
  [Role.CashOfficer]: "0c3e5272-d5e7-414a-b5ac-03de8e627c21",
  [Role.Dispenser]: "7e726562-74bb-4aaa-a506-1bb67a9bb7ab",
  [Role.Sonographer]: "2f367466-4d65-45b0-b8fd-e3411c9e2822",
  [Role.DataExporter]: "8f532f71-6b72-4367-99ea-724aca3bddf6",
  [Role.Performer]: "09f1959d-d545-4977-8dfa-5dbb1132b011",
  [Role.Reviewer]: "111539b8-165c-4a34-94a0-020d59696ea6",
  [Role.QaAdmin]: "85226947-e144-4de6-b90b-053c3ca3924a",
  [Role.ProgramAdmin]: "17503b3c-a85b-4781-9f19-92ed08abfabd",
};

export const ROLE_IDS_TO_NAMES = {
  [ROLE_IDS[Role.Admin]]: Role.Admin,
  [ROLE_IDS[Role.Elephant]]: Role.Elephant,
  [ROLE_IDS[Role.Root]]: Role.Root,
  [ROLE_IDS[Role.Technician]]: Role.Technician,
  [ROLE_IDS[Role.Nurse]]: Role.Nurse,
  [ROLE_IDS[Role.Clinic]]: Role.Clinic,
  [ROLE_IDS[Role.Doctor]]: Role.Doctor,
  [ROLE_IDS[Role.Pharmacist]]: Role.Pharmacist,
  [ROLE_IDS[Role.CashOfficer]]: Role.CashOfficer,
  [ROLE_IDS[Role.Dispenser]]: Role.Dispenser,
  [ROLE_IDS[Role.Sonographer]]: Role.Sonographer,
  [ROLE_IDS[Role.DataExporter]]: Role.DataExporter,
  [ROLE_IDS[Role.Performer]]: Role.Performer,
  [ROLE_IDS[Role.Reviewer]]: Role.Reviewer,
  [ROLE_IDS[Role.QaAdmin]]: Role.QaAdmin,
  [ROLE_IDS[Role.ProgramAdmin]]: Role.ProgramAdmin,
};
